import { render, staticRenderFns } from "./handleVip.vue?vue&type=template&id=66b2e4c7&scoped=true&"
import script from "./handleVip.vue?vue&type=script&lang=js&"
export * from "./handleVip.vue?vue&type=script&lang=js&"
import style0 from "./handleVip.vue?vue&type=style&index=0&id=66b2e4c7&scoped=true&lang=css&"
import style1 from "./handleVip.vue?vue&type=style&index=1&id=66b2e4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2e4c7",
  null
  
)

export default component.exports